import React from 'react';
import { Link } from "MWC";
import { getUrl } from '../../../../helpers/utils/corploansUrl'
import { CORPLOANS } from '../../../../pages/Business/corploansEnv';
import { plural } from "utils/plural";

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
        isMobile = calc.isViewportMobile();

    return (
        <React.Fragment>
                <div className={`loan-conditions-table`}>
                    <div className="loan-conditions-item">
                        <div className="condition-title">{calc.l10n('CALCULATOR_CREDLINE_TRANCHE_SUM')}</div>
                        <div className="condition-text">{model.getCreditSum().toLocaleString('RU-ru', {minimumFractionDigits: 2,
                            maximumFractionDigits: 2})} {calc.l10n('UAH_ICON')}</div>
                    </div>
                    <div className="loan-conditions-item">
                        <div className="condition-title">{calc.l10n('CALCULATOR_CREDLINE_TRANCHE_TERM')}</div>
                        <div className="condition-text">{model.getTrancheTerm().toLocaleString()} {calc.l10n('CALCULATOR_DAYS')}</div>
                    </div>
                    <div className="loan-conditions-item big">
                        <div className="condition-title">{calc.l10n('CALCULATOR_CREDLINE_TRANCHE_COST')}</div>
                        <div className="condition-text">{model.getTrancheCost().toLocaleString('RU-ru', {minimumFractionDigits: 2,
                            maximumFractionDigits: 2})} {calc.l10n('UAH_ICON')}</div>
                    </div>
                </div>
                <div className="loan-conditions-lines">
                    <div className="loan-conditions-item">
                        <div className="condition-title">{calc.l10n('CALCULATOR_CREDLINE_TRANCHE_COMMISSION')} {model.getOneTimeCommission().toLocaleString('RU-ru')}%</div>
                        <div className="condition-text">{model.сalcOneTimeCommission().toLocaleString('RU-ru')} {calc.l10n('UAH_ICON')}</div>
                    </div>
                    <div className="loan-conditions-item">
                        <div className="condition-title">{calc.l10n('CALCULATOR_CREDLINE_TRANCHE_RATE')} {model.getTrancheRate().toLocaleString('RU-ru')}%</div>
                        <div className="condition-text">{model.getTrancheCommission().toLocaleString('RU-ru')} {calc.l10n('UAH_ICON')}</div>
                    </div>
                    <button className='loan-order-btn bold' style={{marginBottom:8}} onClick={() => window.open(getUrl('loanline'))}>{calc.l10n('SEND_APPLICATION')}</button>
                    <div className="disclaimer">{calc.l10n('CALCULATOR_DISCLAIMER')}</div>
                </div>
        </React.Fragment>
    );
}
